// English texts of the "share" area. Keys start with "share."
export default {
  // Roles: labels (select options, member rows) and the same word inside a sentence.
  // Only the displayed text is translated: the values sent to the server stay "viewer", "editor"…
  "share.role.owner": "Owner",
  "share.role.admin": "Admin",
  "share.role.editor": "Editor",
  "share.role.viewer": "Viewer",
  "share.roleInText.owner": "owner",
  "share.roleInText.admin": "admin",
  "share.roleInText.editor": "editor",
  "share.roleInText.viewer": "viewer",
  "share.legend.term": "{role}:",
  "share.legend.viewer": "Can view only",
  "share.legend.editor": "Can view and edit",
  "share.legend.admin": "Can manage users",

  // Sharing a map, inviting someone
  "share.create.title": "Share Document",
  "share.create.entireDocument": "Entire document",
  "share.create.sharing": "Sharing...",
  "share.invite.heading": "Invite User",
  "share.invite.username": "Username",
  "share.invite.permission": "Permission",
  "share.invite.userFound": "User found",
  "share.invite.userNotFound": "No user with this username, or they have no sharing key",
  "share.invite.verifiedInvite": "Verified, invite",
  "share.invite.keyContext": "You're inviting {name} to this map.",
  "share.invite.keyNotVerified": "Invitation cancelled: the invitee's key was not verified.",
  // Name of a shared map whose title is unknown (also the server's invitation title).
  "share.invite.defaultTitle": "Shared map",
  "share.error.noUsername": "Please enter a username",
  "share.error.shareSelf": "You cannot share with yourself",
  "share.error.inviteSelf": "You cannot invite yourself",
  "share.error.createFailed": "Failed to create share",
  "share.error.inviteFailed": "Failed to invite user",
  "share.error.notReady": "Share module not initialized",
  "share.error.ownerKeyFailed": "Failed to store owner DEK on server — aborting share",
  "share.error.roleFailed": "Failed to update role",
  "share.error.invitationsUnavailable": "Could not load invitations",
  "share.error.invitationGone": "Invitation no longer exists",
  "share.error.invitationMismatch": "Invitation identity does not match map authority",
  "share.error.cancelInviteFailed": "Failed to cancel invitation",

  // Sharing settings: members, pending invitations, stop sharing
  "share.manage.title": "Sharing Settings",
  "share.manage.byOwner": "by {name}",
  "share.members.heading": "People with Access",
  "share.members.count_one": "{count} user",
  "share.members.count_other": "{count} users",
  "share.members.empty": "No users added yet",
  "share.members.emptyHint": "Invite someone to collaborate",
  "share.member.unknown": "Unknown",
  "share.member.thisUser": "this user",
  "share.member.remove": "Remove user",
  "share.member.removeConfirm": "Remove {name} from this share?",
  "share.pending.heading": "Pending Invitations",
  "share.pending.count_one": "{count} pending",
  "share.pending.count_other": "{count} pending",
  "share.pending.role": "{role} (pending)",
  "share.pending.cancel": "Cancel invitation",
  "share.pending.cancelConfirm": "Cancel invitation for {name}?",
  "share.pending.cancelFailed": "Failed to cancel invitation. Please try again.",
  "share.danger.heading": "Danger Zone",
  "share.danger.stop": "Stop Sharing",
  "share.danger.stopHint": "Remove access for all users. This cannot be undone.",
  "share.danger.stopConfirm": "Are you sure you want to stop sharing? All users will lose access.",
  "share.section.loading": "Loading...",
  "share.section.loadFailed": "Failed to load sharing info.",
  "share.section.loadingDetails": "Loading share details...",
  "share.section.detailsFailed": "Failed to load share details.",

  // Encryption keys of members (key trust)
  "share.key.changed": "Key changed",
  "share.key.reregistered": "{name} re-registered their encryption key",
  "share.key.reregisteredUnknown": "This user re-registered their encryption key",
  "share.key.restore": "Restore access",
  "share.key.restoreTitle": "Re-share the map key for their new encryption key",
  "share.key.restoring": "Restoring…",
  "share.key.restoreFailed": "Couldn't restore {name}'s access: {error}",
  "share.key.old": "Old key",
  "share.key.oldTitle": "This map still uses a key this person replaced",
  "share.key.differs": "Key differs",
  "share.key.differsTitle": "This person's key here is not the one you saw before. Verify it with them.",
  "share.key.verify": "Verify",
  "share.key.verifyTitle": "Compare their key fingerprint",
  "share.key.differsContext": "Their key in this map differs from the one you saw before.",
  "share.authority.skipped_one": "{count} sharing change on this map couldn't be verified and is ignored.",
  "share.authority.skipped_other": "{count} sharing changes on this map couldn't be verified and are ignored.",
  "share.authority.reconfirm": "Re-confirm sharing",
  "share.authority.ownerMustReconfirm": "The owner needs to open this map's sharing settings to re-confirm its sharing.",
  "share.authority.reconfirmFailed": "Couldn't re-confirm this map's sharing.",

  // Removing a member / stopping sharing (new map key; progress card)
  "share.rotation.removing": "Removing a member",
  "share.rotation.stopping": "Stopping sharing",
  "share.rotation.cancelled": "Nothing was changed. Everyone keeps their access.",
  "share.rotation.checking": "Checking the members…",
  "share.rotation.reading": "Reading the map…",
  "share.rotation.encrypting": "Encrypting the map…",
  "share.rotation.preparingRecovery": "Preparing the recovery copy…",
  "share.rotation.uploading": "Uploading…",
  "share.rotation.saving": "Saving on the server…",
  "share.rotation.relocking": "Re-locking attachment keys…",
  "share.rotation.permissionsFailed": "Failed to fetch permissions",
  "share.rotation.permissionsRetryFailed": "Failed to fetch permissions after retries: {status}",
  "share.rotation.noState": "DEK rotation aborted: no document state available for share {id}. Could not load from memory, IndexedDB, or server.",
  "share.rotation.baselineFailed": "Failed to fetch baseline hash: {status}",
  "share.rotation.memberNoUsername": "DEK rotation aborted: member {id} has no username. Cannot wrap DEK for all active members.",
  "share.rotation.membershipDiffers": "Membership differs from authenticated map authority. Refresh before rotating.",
  "share.rotation.wrapFailed": "DEK rotation aborted: could not wrap DEK for user {name}: {error}",
  "share.rotation.invitationsUnreadable": "Rotation paused: pending invitations could not be read.",
  "share.rotation.invitationDiffers": "Rotation paused: an invitation differs from authenticated map authority.",
  "share.rotation.casGaveUp": "CAS conflict after {retries} retries — giving up",
  "share.rotation.requestFailed": "Rotate request failed: {status}",
  "share.rotation.filenameLost": "Rotation paused: an attachment filename could not be preserved.",
  "share.rotation.serverStateUnreadable": "Rotation paused: server state could not be read.",
  "share.rotation.updateUnreadable": "Rotation paused: an update could not be read. Local and server data are retained.",
  "share.rotation.localStateUnreadable": "Rotation paused: local state could not be read ({error}).",

  // Recovering a map after access was revoked
  "share.recovery.defaultTitle": "Recovered Map",
  // Name of the recovered copy.
  "share.recovery.copyName": "{title} (recovered)",
  "share.recovery.incomplete": "Recovery is incomplete. The original recovery data is retained. Free space if needed, then retry recovery.",
  "share.recovery.confirmFailed": "Failed to confirm share recovery. Please try refreshing the page.",

  // Requesting access to a linked map (shown after "Request failed:")
  "share.accessRequest.networkError": "network error",

  // Inbox (notifications and invitations)
  "share.inbox.title": "Inbox",
  "share.inbox.notifications": "Notifications",
  "share.inbox.invitations": "Invitations",
  "share.inbox.empty": "No pending notifications",
  "share.inbox.emptyHint": "Share invitations and updates will appear here",
  "share.inbox.from": "From {name}",
  "share.inbox.accept": "Accept",
  "share.inbox.acceptTitle": "Accept invitation",
  "share.inbox.accepting": "Accepting...",
  "share.inbox.accepted": "Accepted",
  "share.inbox.acceptError": "Couldn't accept the invitation: {error}",
  "share.inbox.tryAgain": "please try again.",
  "share.inbox.decline": "Decline",
  "share.inbox.declineTitle": "Decline invitation",
  "share.inbox.declineConfirm": "Decline this invitation?",
  "share.inbox.declining": "Declining...",
  "share.inbox.declineFailed": "Failed to decline invitation. Please try again.",
  "share.inbox.ignore": "Always ignore",
  "share.inbox.ignoreTitle": "Always ignore invitations from this person",
  "share.inbox.ignoreConfirm": "Always ignore invitations from {name}? They are not told. Their invitations waiting here go too. You can change this in your account.",
  "share.inbox.ignored": "Invitations from {name} will be ignored. You can change this in your account.",
  "share.inbox.ignoreFailed": "Could not ignore these invitations. Please try again.",
  "share.error.invitationWaiting": "{name} has not accepted your first invitation yet: you can invite them to more maps once they have.",
  "share.error.sentPerDay": "You sent too many invitations today. Please try again tomorrow.",
  "share.error.receivedPerDay": "{name} received too many invitations today. Please try again tomorrow.",
  "share.inbox.recover": "Recover",
  "share.inbox.recoverTitle": "Recover shared data",
  "share.inbox.recovering": "Recovering...",
  "share.inbox.recovered": "Recovered",
  "share.inbox.noData": "No data available",
  "share.inbox.grant": "Grant access",
  "share.inbox.grantTitle": "Open share dialog to grant access",
  "share.inbox.dismiss": "Dismiss",
  "share.inbox.dismissConfirm": "Dismiss without recovering? The local cached copy will be cleared and you will lose access to the shared data.",
  "share.inbox.dismissFailed": "Failed to dismiss notification. Please try again.",
  "share.inbox.markReadFailed": "Failed to mark notification as read",
  "share.inbox.justNow": "Just now",
  "share.inbox.loadInvitationsFailed": "Couldn't load your invitations. Please try again.",
  "share.inbox.invitationGone": "This invitation is no longer available",
  "share.inbox.acceptFailed": "Failed to accept invitation",
  "share.inbox.declineError": "Failed to decline invitation",
  "share.inbox.notAccepted": "Invitation not accepted.",

  // An invitation that answers the user's own access request
  "share.join.title": "Access granted",
  "share.join.message": "{name} granted your request for access to “{title}” as {role}.",
  "share.join.theOwner": "The owner",
  "share.join.aMap": "a map",
  "share.join.confirm": "Join map",
  "share.join.toast": "Access granted: \"{title}\".",

  // Maps accepted earlier that an older app version didn't add to the vault
  "share.adopt.title_one": "Add a shared map to your vault?",
  "share.adopt.title_other": "Add {count} shared maps to your vault?",
  "share.adopt.explain": "You accepted these maps earlier, but an older version of the app didn't add them to your vault.",
  "share.adopt.unverified": "{role} — no verified sharing history, its key can't be verified",
  "share.adopt.keyDiffers": "{name}'s key is not the one you saw before.",
  "share.adopt.keyDiffersUnknown": "A member's key is not the one you saw before.",
  "share.adopt.checkbox": "I compared these fingerprints with their owners and they match.",
  "share.adopt.add": "Add to vault",
  "share.adopt.addAll": "Add all to vault",
  "share.adopt.notNow": "Not now",
  "share.adopt.entryTitle": "Shared map from {name}",

  // Server notifications, written on this device from their type and data.
  // English matches the server's texts (orbital_backend handlers/shares).
  "share.notif.revoked.title": "Access to a document has been revoked",
  "share.notif.revoked.titleNoSnapshot": "Access to a shared document has been revoked",
  "share.notif.revoked.titled": "Access revoked: {title}",
  "share.notif.revoked.named": "Access to \"{title}\" has been revoked",
  "share.notif.revoked.messageSnapshot": "Your access has been revoked. You can recover your data including the latest changes.",
  "share.notif.revoked.messageNoSnapshot": "Your access has been revoked. A local copy was saved to your maps.",
  "share.notif.accessRequest.title": "{name} wants access to a map",
  "share.notif.accessRequest.named": "{name} wants access to “{title}”",
  "share.notif.accessRequest.message": "Review the request and grant access if appropriate.",
  "share.notif.someone": "Someone",
  "share.notif.keyChanged.title": "{name}'s encryption key changed",
  "share.notif.keyChanged.reregistered": "They re-registered their encryption key. Open the sharing settings of the maps you share with them and restore their access.",
  "share.notif.keyChanged.restored": "The map owner restored their access with a new encryption key. Compare their key fingerprint with them before sharing anything sensitive.",
  "share.notif.keyChanged.maps": "Maps: {maps}.",

  // Sharing section of a map on this device
  "share.local.message": "This map is stored on this device only. Move it online to share it; it will also sync to your other devices.",
  "share.local.noServer": "This map is stored on this device only. Sharing needs a server.",
  // Sharing with a link (docs/plans/2026-10-28-link-sharing.md)
  "share.link.heading": "Anyone with the link",
  "share.link.on": "On",
  "share.link.off": "Off",
  "share.link.create": "Create link",
  "share.link.copy": "Copy link",
  "share.link.copied": "Link copied",
  "share.link.copyFailed": "Could not copy the link: select it and copy it.",
  "share.link.preparing": "Preparing the link…",
  "share.link.renew": "New link",
  "share.link.turnOff": "Turn off",
  "share.link.turningOff": "Turning off the link",
  "share.link.renewing": "Making a new link",
  "share.link.error.gone": "This link no longer works: ask for a new one.",
  "share.link.error.exists": "This map already has a link.",
  "share.link.error.noKey": "Your account has no encryption key yet: reload and try again.",
  "share.link.error.loadFailed": "Could not read the map's link.",
  "share.link.error.createFailed": "Could not make the link.",
  "share.link.error.changeFailed": "Could not change the link.",
  "share.link.error.openFailed": "Could not open this link.",
  "share.link.error.invalid": "This is not a link to a map.",
  "share.rotation.linkUnreadable": "Could not read the map's link. Try again.",
  "share.link.opensAs": "Opens as",
  "share.link.hintOff": "Anyone who has the link can open the map, with or without an account, without becoming a member.",
  "share.link.hintOn": "Anyone who has this link can open the map, with or without an account. They are not members: turn the link off or make a new one to cut them all off.",
  "share.link.status": "Anyone with the link can open this map as {role}.",
  "share.link.ownerOnly": "Only the owner changes the link or turns it off.",
  "share.link.turnOffConfirm": "Turn off the link? Everyone who opens the map with it loses access (the map’s key changes).",
  "share.link.renewConfirm": "Make a new link? The current one stops working: everyone who opens the map with it loses access until they get the new link (the map’s key changes).",
  "share.link.stillOpenAfterRemoval": "{name} can still open the map with its link, if they have it. Make a new link? (The current one stops working for everyone.)",
  "share.link.noFiles": "Only the map’s members can add files.",
  "share.link.error.tooMany": "Too many links opened from here: try again in a minute.",
  "share.link.open.opening": "Opening the shared map…",
  "share.link.open.kept": "“{title}” is open. It stays in your maps as long as its link works.",
  "share.link.open.page": "“{title}” is open; it is not added to your maps.",
  "share.link.open.member": "This map is already shared with you: find it in your maps.",
  "share.link.open.signIn": "Sign in or create an account: the shared map is then kept in your maps.",
  "share.link.holder.title": "Opened with its link",
  "share.link.holder.text": "You have this map through its link, as {role}. Anyone with the link can open it; you are not a member.",
  "share.link.holder.remove": "Remove from my maps",
  "share.link.holder.removeConfirm": "Remove “{title}” from your maps? You can open it again with its link while the link works.",
  "share.link.gone.title": "This map’s link no longer works",
  "share.link.gone.text": "The link was turned off or replaced. The copy on this device stays readable: duplicate or export it from your maps to keep it.",
  "share.link.goneShort": "link no longer works",
  "share.link.viaLink": "via link",
  "share.link.page.banner": "“{title}” is open with its link, as {role}. It is not kept: sign in to keep it in your maps.",
  "share.link.page.signIn": "Sign in",
  "share.link.gone.textPage": "The link was turned off or replaced. The map stays readable on this page until you close it; you can export it from the menu.",
  "share.link.open.yours": "“{title}” is already shared with you: it is open.",
  "share.link.open.own": "“{title}” is your map: it is open.",
};
